import { MenuItemWrapper } from '../MenuItemWrapper/MenuItemWrapper';
import { MenuButton } from '../MenuButton/MenuButton';
import * as s from './MenuItem.scss';
import { NavigationItem } from '../../data/types';
import { Translator } from '../../modules/translate';
import { SubMenu } from '../SubMenu/SubMenu';
import { DataHook } from '../../modules/dataHooks';

export interface MenuItemProps {
  item: NavigationItem;
  t: Translator;
}

export const MenuItem = ({ item, t }: MenuItemProps) => {
  const id = `main-menu-item-${item.name}`;
  const isBigDropdown = !!item.subs && item.subs?.length > 4;
  return MenuItemWrapper({
    item,
    className: `${s.menuItemWrapper} ${isBigDropdown ? s.twoColumnsWrapper : ''}`,
    dataHook: DataHook.MainMenuItem,
  })(`
    ${MenuButton({ item, t, id })}
    ${
      item.subs
        ? SubMenu({
            items: item.subs,
            blockButton: item.sideBlockInfoButton,
            blockList: item.sideBlockInfo,
            title: item.sideBlockInfoTitle,
            t,
            isBigDropdown,
            id,
          })
        : ''
    }
  `);
};
